<template>
  <div ref="imageContainer" class="modal-overlay-zoom-images" :class="{ 'zoomed-image': isZoomedIn }">
    <slot />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue';

import { useTraits } from '@nuxt-common/media-card-large/app/composables/useTraits';
import useOnModalChange from '~/composables/utils/useOnModalChange';
import { useImageZoomer } from '~/modules/image-zoomer/composables/useImageZoomer';
import { usePageData } from '~/composables/usePageData';
import { tagImageZoom } from '~/features/analytics/image';

const props = defineProps({
  currentPage: {
    type: Number,
    default: 1,
  },
  topLevelApplied: {
    type: Boolean,
    default: false,
  },
});

const { productId } = usePageData();
const { selectedColorId } = useTraits(productId);
const imageContainer = ref(null);

const { start, destroy, resetImage, isZoomedIn } = useImageZoomer(imageContainer, props.topLevelApplied);

onMounted(start);
// remove listener instance everytime component is unmounted (i.e. when modal closes)
onUnmounted(destroy);

watch(isZoomedIn, (isZoomed) => {
  tagImageZoom(isZoomed);
});

watch([() => props.currentPage, selectedColorId], resetImage);

// modal change behavior should only be observed from the top level instance
if (props.topLevelApplied) {
  // listen to modal events from top-level component
  useOnModalChange('main-image-overlay', {
    onShow: destroy.bind(null, true), // removes current 'mouse-move' event attached to the body
    onClose: start.bind(null, true), // reassigns 'mouse-move' event to body from top-level instance
  });
}
</script>
<style lang="scss">
.zoomed-image {
  z-index: 5;
  width: 100%;
}
.modal-overlay-zoom-images {
  margin: 0 auto;
  width: 100%;
}
</style>
